import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { ColorPickerModule } from 'primeng/colorpicker';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SkeletonModule } from 'primeng/skeleton';

import { AreasComponent } from './areas.component';
import { AreasListComponent } from './areas-list/areas-list.component';
import { AreaFormComponent } from './area-form/area-form.component';
import { AreaItemListComponent } from './areas-list/area-item-list/area-item-list.component';
import { PipesModule } from '@commons/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';

const components = [
  AreasComponent,
  AreasListComponent,
  AreaFormComponent,
  AreaItemListComponent
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    CommonModule,
    InputTextModule,
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AccordionModule,
    ButtonModule,
    MultiSelectModule,
    ColorPickerModule,
    TooltipModule,
    ProgressSpinnerModule,
    SkeletonModule,
    PipesModule,
    TranslateModule,
  ]
})
export class AreasModule { }
